import React from 'react';
import { Grape, Twitter, Linkedin, Github } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300 py-16" data-id="element-135">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-136">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-12 mb-12" data-id="element-137">
          {/* Brand Column */}
          <div className="lg:col-span-3" data-id="element-138">
            <div className="flex items-center mb-6" data-id="element-139">
              <div className="bg-gray-800 p-2 rounded-lg mr-2" data-id="element-140">
                <Grape className="h-6 w-6 text-violet-400" data-id="element-141" />
              </div>
              <span className="text-xl font-bold text-white tracking-tight" data-id="element-142">
                Berry Finance
              </span>
            </div>
            <p className="text-gray-400 mb-6 max-w-sm" data-id="element-143">
              Automated financial reconciliation for modern businesses. Save
              time, reduce errors, and gain confidence in your numbers.
            </p>
            <div className="flex space-x-4" data-id="element-144">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-145">

                <Twitter className="h-5 w-5" data-id="element-146" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-147">

                <Linkedin className="h-5 w-5" data-id="element-148" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-149">

                <Github className="h-5 w-5" data-id="element-150" />
              </a>
            </div>
          </div>

          {/* Links Columns */}
          <div data-id="element-151">
            <h4 className="text-white font-bold mb-6" data-id="element-152">Product</h4>
            <ul className="space-y-4" data-id="element-153">
              <li data-id="element-154">
                <a href="#features" className="hover:text-violet-400 transition-colors" data-id="element-155">
                  Features
                </a>
              </li>
              <li data-id="element-156">
                <a href="#how-it-works" className="hover:text-violet-400 transition-colors" data-id="element-157">
                  How it works
                </a>
              </li>
              <li data-id="element-158">
                <a href="#pricing" className="hover:text-violet-400 transition-colors" data-id="element-159">
                  Pricing
                </a>
              </li>
              <li data-id="element-160">
                <a href="#" className="hover:text-violet-400 transition-colors" data-id="element-161">
                  Roadmap
                </a>
              </li>
           
            </ul>
          </div>

          {/* <div>
           <h4 className="text-white font-bold mb-6">Company</h4>
           <ul className="space-y-4">
            <li>
              <a href="#" className="hover:text-violet-400 transition-colors">
                About Us
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-violet-400 transition-colors">
                Careers
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-violet-400 transition-colors">
                Blog
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-violet-400 transition-colors">
                Contact
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-violet-400 transition-colors">
                Partners
              </a>
            </li>
           </ul>
           </div> */}

          <div data-id="element-162">
            <h4 className="text-white font-bold mb-6" data-id="element-163">Legal</h4>
            <ul className="space-y-4" data-id="element-164">
              <li data-id="element-165">
                <a href="#" className="hover:text-violet-400 transition-colors" data-id="element-166">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-167">
                <a href="#" className="hover:text-violet-400 transition-colors" data-id="element-168">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-169">
                <a href="#" className="hover:text-violet-400 transition-colors" data-id="element-170">
                  Security
                </a>
              </li>
              {/* <li>
               <a href="#" className="hover:text-violet-400 transition-colors">
                 Cookie Policy
               </a>
               </li> */}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center" data-id="element-171">
          <p className="text-gray-500 text-sm mb-4 md:mb-0" data-id="element-172">
            © 2026 Berry Finance, A Stasis Group Digital PTY LTD Product. All rights reserved.
          </p>
          <div className="flex space-x-6 text-sm text-gray-500" data-id="element-173">
            <span data-id="element-174">Made with 💜 for finance teams</span>
          </div>
        </div>
      </div>
    </footer>;
}